import { inject } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import * as React from 'react';

import { ErrorBoundary, Layer } from 'bernie-view';
import { QueryRoute, RouteStore } from 'bernie-core';

import { PropertyWhatsAround } from '@shared-ui/lodging-property-details';
import { RefTarget } from '@shared-ui/ref-context';
import { useLocalization } from '@shared-ui/localization-context';

import { UitkSpacing } from 'uitk-react-spacing';

import { SharedUiMap } from './map-wrapper';
import { SharedUiWrapperProps, withSharedUiPropertyDetails } from './shared-ui-property-details';

interface WhatsAroundProps extends SharedUiWrapperProps {
  routeStore?: RouteStore;
  history: {
    push: (submitUrl: string) => void;
  };
}

/* istanbul ignore next */
const WhatsAroundWrapper: React.FC<WhatsAroundProps> = inject('routeStore')(({ inputs, routeStore, history }) => {
  const l10n = useLocalization();

  if (!routeStore) {
    return null;
  }

  const queryBase = { pwaDialog: 'map-whats-around' };
  const mapOpenQuery = routeStore.mergeQueryString(routeStore.search, queryBase);
  const linkTo = `${routeStore.pathname}?${mapOpenQuery}`;

  const onMapDialogOpen = () => history?.push(linkTo);
  const onMapDialogClose = () => routeStore?.goBack();

  return (
    <ErrorBoundary label="hotel.information.whats-around.map">
      <QueryRoute query={queryBase}>
        <Layer id="infosite-map-whats-around" onDismiss={onMapDialogClose}>
          <SharedUiMap onClose={onMapDialogClose} />
        </Layer>
      </QueryRoute>
      <UitkSpacing margin={{ block: 'six' }}>
        <RefTarget name="Location" dataStid="whats-around">
          <PropertyWhatsAround
            inputs={inputs}
            mapA11y={l10n.formatText('hotels.infosite.map.a11yLabel')}
            mapCTALabel={l10n.formatText('hotels.searchResults.openMapDialog.label')}
            triggerMap={onMapDialogOpen}
          />
          <a itemProp="hasMap" href={linkTo} className="is-visually-hidden">
            {l10n.formatText('hotels.searchResults.openMapDialog.label')}
          </a>
        </RefTarget>
      </UitkSpacing>
    </ErrorBoundary>
  );
});

export const SharedUiWhatsAroundWrapper = withSharedUiPropertyDetails(withRouter(WhatsAroundWrapper));
SharedUiWhatsAroundWrapper.displayName = 'SharedUiWhatsAroundWrapper';
